<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
            :page-title="pageTitle"
            :directory="$t('datatables')"
            :icon="'grid'"
        />
      </div>
    </div>
    <div class="card card-with-shadow border-0">
      <app-overlay-loader v-if="preloader"/>
      <div class="card-body">
        <form ref="form"
              :data-url="formUrl"
              class="mb-0"
              :class="{'loading-opacity': preloader}"
              method="post">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label class="h-fit-content font-weight-bold">
                  Email the registration link to given user.
                </label>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 h-fit-content mt-2">
                  {{ $t('application_first_name') }}
                </label>
                <div class="col-sm-6">
                  <app-input type="text"
                             :required="true"
                             :min-length="2"
                             :max-length="20"
                             id="first_name"
                             :placeholder="$t('application_first_name')"
                             v-model="applicationObj.first_name"/>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 h-fit-content mt-2">
                  {{ $t('application_last_name') }}
                </label>
                <div class="col-sm-6">
                  <app-input type="text"
                             :required="true"
                             id="last_name"
                             :placeholder="$t('application_last_name')"
                             v-model="applicationObj.last_name"/>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 h-fit-content mt-2">
                  {{ $t('application_email_address') }}
                </label>
                <div class="col-sm-6">
                  <app-input type="text"
                             :required="true"
                             id="email_address"
                             :placeholder="$t('application_email_address')"
                             v-model="applicationObj.email_address"/>
                </div>
              </div>
              <div class="form-group row">
                <p class="col-sm-10">
                  Please ensure that this field contains the applicant’s email address. Failure to use
                  the applicant’s email address may result in the application being rejected by Disclosure
                  Services or withdrawn by the Disclosure Agency with no refund being given.
                </p>
              </div>
              <div class="mt-2 action-buttons">
                <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                  {{ $t('Send Invitation') }}
                </button>
                <button type="submit" class="btn btn-secondary" @click.prevent="cancel">
                  {{ $t('Cancel') }}
                </button>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group row">
                <label class="h-fit-content font-weight-bold">
                  Generate registration link.
                </label>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <button type="submit" class="btn btn-secondary" @click.prevent="generateLink">
                    {{ $t('Generate Public Link') }}
                  </button>
                  <fragment v-if="publicLink != ''">
                    <app-input type="text" v-model="publicLink" :read-only="true"/>
                  </fragment>
                </div>
                <div class="col-sm-12 mt-4">
                  <button type="submit" class="btn btn-secondary" @click.prevent="copyLink">
                    {{ $t('Copy Link') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {CREATE_NEW_APPLICATION} from "@/app/Config/ScreeningAppUrl";
import {FormMixin} from '../../../../../core/mixins/form/FormMixin.js';
import {agencyList, organizationList, positionList} from '@Views/Screening/utility/constant';
import {NewApplication} from "@Views/Screening/utility/apiAgent";

export default {
  name: "CreateNewApplication",
  mixins: [FormMixin],
  props: {},
  data() {
    return {
      pageTitle: 'Create New Application',
      applicationObj: {},
      formUrl: CREATE_NEW_APPLICATION,
      preloader: false,
      organizationList: organizationList,
      positionList: positionList,
      agencyList: agencyList,
      publicLink: ''
    };
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.applicationObj);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.applicationObj = {};
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    cancel() {
      this.applicationObj = {};
      this.fieldStatus = {
        isSubmit: false
      }
    },
    generateLink() {
      NewApplication.getPublicAppLink()
          .then((response) => {
            this.publicLink = response.data;
            this.$toastr.s('Link Generated.');
          })
    },
    copyLink() {
      if (this.publicLink != '') {
        const storage = document.createElement('textarea');
        storage.value = this.publicLink;
        document.body.appendChild(storage);
        storage.select();
        storage.setSelectionRange(0, 99999);
        try {
          document.execCommand('copy');
          this.$toastr.s('Link Copied.')
        } catch (err) {
          this.$toastr.e('Failed to copy text.')
          console.error('Failed to copy text: ', err);
        }
        document.body.removeChild(storage);
        return;
      }
      this.$toastr.e('No Link Generated.')
    }
  }
}
</script>

<style scoped>

</style>